import { FetchBuckets } from 'components/Fetch/FetchBuckets'
import Loader from 'components/SimpleLoader'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import FavoritesCarousel from 'routes/find/routes/home/components/FavoritesCarousel'
import RecentlyViewedCarousel from 'routes/find/routes/home/components/RecentlyViewedCarousel'
import { EVENT_ACTIVATE_PROFILES, EVENT_SETUP_PLAN } from 'routes/trial/interfaces'
import { fetchTrainingVideoSections, getTrialTasks } from 'services/users/actions'
import { trialTasksRecordSelector } from 'services/users/selectors'
import { StoreThunkDispatch } from 'store/state'
import { ManagePostsCarousel } from './ManagePostsCarousel'
import { QuickActions } from './QuickActions'
import { GettingStarted } from './components/GettingStarted/GettingStarted'

export function Homepage() {
  const dispatch = useDispatch<StoreThunkDispatch>()
  const onboardingTasks = useSelector(trialTasksRecordSelector)
  const [loading, setLoading] = useState(true)

  const requiredOnboardingTasksComplete = [EVENT_ACTIVATE_PROFILES, EVENT_SETUP_PLAN].every(eventCode => {
    return onboardingTasks[eventCode]?.completed
  })

  useEffect(() => {
    Promise.all([
      dispatch(getTrialTasks(false)).unwrap(),
      dispatch(fetchTrainingVideoSections(false)).unwrap()
    ])
      .catch((e) => {
        console.error('Error fetching getting started data', e)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [dispatch])

  if (loading) {
    return <div><Loader /></div>
  }

  return (
    <div>
      {requiredOnboardingTasksComplete ? <QuickActions /> : <GettingStarted />}
      <ManagePostsCarousel />
      {requiredOnboardingTasksComplete && (
        <>
          <FavoritesCarousel title="Post your favorite content 😍" />
          <RecentlyViewedCarousel title="Curate viral content 🔥" />
        </>
      )}
      <FetchBuckets />
    </div>
  )
}
